import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useExhibitorAuthContext } from '../../../../Context/AuthContex/ExhibitorAuthContext';
import {
  IRegisteredStaff,
  useUpdateRegisteredStaffPost,
} from './apiEndpoints/registeredVisitorEndpoint';
import StaffForm from './StaffForm';
interface EditStaffProps {
  dataStaff: IRegisteredStaff | undefined;
  handleModalOff?: () => void;
}
const EditStaff: React.FC<EditStaffProps> = ({ dataStaff, handleModalOff }) => {
  const {
    state: { exhibitorUser },
  } = useExhibitorAuthContext();
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    resetField,
    reset,
    formState: { errors },
  } = useForm<any>();

  const { mutate, isSuccess, isPending } = useUpdateRegisteredStaffPost(
    Number(dataStaff?.id)
  );

  const onSubmit = async (data: any) => {
    const formData = new FormData();
    Object?.keys(data)?.forEach((key) => {
      if (typeof data[key] === 'object' && data[key] !== null) {
        console.log('inside', data[key]);
        formData?.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    });
    mutate(formData);
  };

  useEffect(() => {
    const { created_at, id, updated_at, id_no, ...rest } = dataStaff || {};
    if (dataStaff) {
      reset({ ...rest });
    }
  }, [dataStaff]);
  useEffect(() => {
    if (isSuccess) {
      handleModalOff && handleModalOff();
    }
  }, [isSuccess]);

  return (
    <div className='profile-right-side px-3 py-3 mb-2'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <StaffForm
          register={register}
          setValue={setValue}
          clearErrors={clearErrors}
          resetField={resetField}
          errors={errors}
          setError={setError}
          btnText='Edit Staff'
          loading={isPending}
          imageDefaultValue={dataStaff?.photo}
        />
      </form>
    </div>
  );
};

export default EditStaff;
